'use client';

import { Button, cn } from '@repo/ui';
import { Home } from 'lucide-react';
import Link from 'next/link';
import type React from 'react';
import { LazyLottie } from '../../components/lazy-lottie';

interface IError404TemplateProps extends React.ComponentProps<'div'> {
  homeHref?: string;
  eyebrow: string;
  title: string;
  body: string;
  ctaHome: string;
}

export function Error404Template({
  className,
  homeHref = '/',
  eyebrow,
  title,
  body,
  ctaHome,
  ...props
}: IError404TemplateProps): React.ReactNode {
  return (
    <div
      className={cn(
        'flex min-h-[100svh] flex-col items-center justify-center gap-5 px-6 py-10 select-none',
        className,
      )}
      {...props}
    >
      <LazyLottie
        src="/lottie/error-404.lottie.json"
        className="w-36 sm:w-44 rounded-2xl overflow-hidden"
      />
      <div className="flex max-w-xl flex-col items-center gap-2 text-center">
        <span className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
          {eyebrow}
        </span>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
        <p className="text-base text-muted-foreground">{body}</p>
      </div>
      <Button asChild>
        <Link href={homeHref}>
          <Home />
          {ctaHome}
        </Link>
      </Button>
    </div>
  );
}
